// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__gDoVJ","shimmer":"Skeleton_shimmer__eh0NK","circular":"Skeleton_circular__6O6xj","text":"Skeleton_text__yqZPM"};